if (window.__cardsSlideshowLoaded) {
  // Prevent duplicate script tags from redeclaring slideIndex.
} else {
  window.__cardsSlideshowLoaded = true;

  document.addEventListener("DOMContentLoaded", showSlides);

  function currentSlide(n) {
    showSlides((window.slideIndex = n));
  }

  window.slideIndex = 0;

  function showSlides() {
    let pairs = [];
    let slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");

    for (let i = 0; i < slides.length; i += 3) {
      let pair = [slides[i], slides[i + 1], slides[i + 2]];
      pairs.push(pair);
    }

    pairs.forEach((pair) => {
      for (let i = 0; i < pair.length; i++) {
        if (i < 2) {
          if (pair[i]) pair[i].style.display = "none";
          if (pair[i + 1]) pair[i + 1].style.display = "none";
        } else {
          if (pair[i]) pair[i].style.display = "none";
          if (pair[0]) pair[0].style.display = "none";
        }
      }
    });

    for (let i = 0; i < dots.length; i++) {
      dots[i].style.backgroundColor = "#ffffff85";
    }

    window.slideIndex++;

    if (window.slideIndex > 3) {
      window.slideIndex = 1;
    }

    pairs.forEach((pair) => {
      const slide = pair[window.slideIndex - 1];
      if (slide) slide.style.display = "flex";
    });

    let dotContainer = document.querySelectorAll("#dot-container");
    dotContainer.forEach((dot) => {
      const activeDot = dot.children[window.slideIndex - 1];
      if (activeDot) activeDot.style.backgroundColor = "#ffffff";
    });
  }

  setInterval(showSlides, 4000);
}
